import React, {FC, useState} from 'react';

import {CollapseFAQ, Modal, zIndex} from '@optimaxdev/design-system';
import {Icon, Exit} from '@optimaxdev/icons';
import classNames from 'classnames';

import {SubscribeBenefits} from '../subscribeBenefits/subscribeBenefits';

import s from './cartItemTooltip.scss';

const modalOptions = {overlay: 'dark' as const, zIndex: zIndex.popup};

type PropsType = {textStyle?: string; onPopupOpen?: () => void};

const FAQ = [
    {
        anchor: 'How works?',
        description:
            'Your subscription order will arrive at your doorstep every 1, 3 or 6 months, according to your preference. You will be charged each time your lenses are shipped unless you cancel or pause your subscription.',
        title: 'How does the subscription work?',
    },
    {
        anchor: 'Change or cancel?',
        description:
            'You can cancel, change or pause your subscription at any time via the My Account page at GlassesUSA.com.  Make sure that you are logged in to update your preferences. You will not be charged a cancellation fee.',
        title: 'How do I change or cancel my subscription?',
    },
    {
        anchor: 'Any costs?',
        description: 'No, shipping is free, and we ship anywhere in the US.',
        title: 'Are there any extra shipping costs?',
    },
    {
        anchor: 'Prescription changes?',
        description:
            'That’s not a problem! If you have your new prescription, you can update us by chat or email and we will adjust your subscription order accordingly. If you don’t have your updated prescription, please contact us and we will assist you.',
        title: 'What happens if my prescription changes?',
    },
    {
        anchor: 'How to return?',
        description:
            'As always at GlassesUSA.com, your purchase is risk-free and includes free returns. You will get a full refund for any unopened boxes of contact lenses. You can start the returns process on our live chat. You’ll be sent a shipping label via email after you complete your return.',
        title: 'Can I return the lenses?',
    },
];

/**
 * "Learn more" popup for the CL item in the cart with enabled subscription
 * @returns {React.ReactElement} - popup component
 */
export const CartItemPopup: FC<PropsType> = ({onPopupOpen, textStyle}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isFAQ, setIsFAQ] = useState(false);

    /**
     * Click handler for the "Learn More" button
     */
    const onButtonClick = () => {
        if (onPopupOpen) onPopupOpen();
        setIsOpen(true);
    };

    return (
        <>
            <button className={classNames(s.text, textStyle)} onClick={onButtonClick} type="button">
                Learn more.
            </button>
            <Modal
                {...modalOptions}
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                withoutCloses
            >
                <section className={s.container}>
                    <button
                        aria-label="Close modal"
                        className={s.closeButton}
                        onClick={() => setIsOpen(false)}
                        type="button"
                    >
                        <Icon height={14} icon={Exit} strokeWidth={2} width={14} />
                    </button>
                    <h1 className={s.header}>Subscribe & Save</h1>
                    <div className={s.wrap}>
                        <SubscribeBenefits />
                        {!isFAQ && (
                            <p className={s.question}>
                                Have a question?{' '}
                                <button
                                    className={s.buttonFaq}
                                    onClick={() => setIsFAQ(true)}
                                    type="button"
                                >
                                    Open FAQs.
                                </button>
                            </p>
                        )}
                    </div>
                    {isFAQ && <CollapseFAQ collapses={FAQ} />}
                </section>
            </Modal>
        </>
    );
};
